let id = 0;


/**
 * @typedef CustomStorage
 * @property {function(string):string|number|null|undefined} getItem
 * @property {function(string,any)}setItem
 * @property {function()}clear
 * @property {function(string):boolean}removeItem
 */

/**
 *
 * @param a
 * @returns {CustomStorage}
 */
function getStorage(a) {
    let store = [sessionStorage, localStorage][a];
    if (window.isIOS && window.isApp) {
        const callBack = window.cabk;
        const sto0 = window.sto0;
        const sto1 = window.sto1;
        const v = '\0';
        const sto = [sto0, sto1][a];
        const p = window.parent;
        /**
         * @type CustomStorage
         */
        const o = {
            getItem(s) {
                callBack[id] = a + s;
                p.postMessage(`${v}0${a}${s}${v}${id}`, '*')
                id++
                return sto[s]
            },
            setItem(s, va) {
                va = va + '';
                sto[s] = va;
                p.postMessage(`${v}1${a}${s}${v}${va}`, '*')
            },
            removeItem(s) {
                p.postMessage(`${v}2${a}${s}`, '*')
                return delete sto[s]
            },
            clear() {
                p.postMessage(`${v}3${a}`, '*')
                Object.keys(sto).forEach(k => delete sto[k])
            }
        }
        let validator = {
            get: function (obj, prop) {
                switch (prop) {
                    case 'getItem':
                        return k => {
                            let v = obj.getItem(k)
                            if (!/{/.test(v)) {
                                try {
                                    const o = JSON.parse(v)
                                    if (typeof o !== 'string') v = o
                                } catch (e) {
                                }
                            }
                            return v
                        };
                    case 'setItem':
                        return obj.setItem;
                    case 'removeItem':
                        return obj.removeItem;
                    case 'clear':
                        return obj.clear;
                    default:
                        return obj.getItem(prop);
                }
            },
            set: function (obj, prop, value) {
                obj.setItem(prop, value)
                return true;
            }
        };
        store = new Proxy(o, validator);
    }
    return store
}

export const localStore = getStorage(1)
export const sessionStore = getStorage(0)
Object.defineProperty(window, 'api', {
    get() {
        return (localStore.api || window.location.host).replace(/^[^.]+/, 'api');
    }
})
